import styled, { createGlobalStyle } from 'styled-components'

import { Input } from '@interco/inter-ui/components/Input'

export const GlobalFAQStyles = createGlobalStyle`
  body.faq-page #faq-search {
    padding-left: 48px !important;
    padding-right: 48px !important;
    width: 100% !important;
  }

  body.faq-page [data-testid='label-faq-search'] {
    display: none !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
  }

  body.faq-page [data-testid='input-faq-search'] {
    padding-left: 48px !important;
    padding-right: 48px !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
    width: 100% !important;
    box-sizing: border-box !important;
    line-height: 1.5 !important;
    font-size: 1rem !important;
  }

  body.faq-page [data-testid='input-faq-search']::placeholder {
    color: var(--gray300) !important;
    opacity: 1 !important;
  }

  body.faq-page #faq-search[data-testid='input-faq-search'] {
    padding-left: 48px !important;
    padding-right: 48px !important;
    width: 100% !important;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 12px;
  width: 100%;
`

export const SearchContainer = styled.div`
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-bottom: 0;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: 1px solid var(--gray200);
  box-sizing: border-box;
`

export const CustomInput = styled(Input)`
  margin: 0 !important;
  width: 100% !important;

  & > div {
    margin: 0 !important;
    width: 100% !important;
  }

  & label[data-testid='label-faq-search'] {
    display: none !important;
    margin: 0 !important;
    height: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
  }

  & input[data-testid='input-faq-search'] {
    padding-left: 48px !important;
    padding-right: 48px !important;
    width: 100% !important;
    box-sizing: border-box !important;

    &::placeholder {
      color: var(--gray300) !important;
      opacity: 1 !important;
    }
  }

  & input#faq-search {
    padding-left: 48px !important;
    padding-right: 48px !important;
    width: 100% !important;
    box-sizing: border-box !important;

    &::placeholder {
      color: var(--gray300) !important;
      opacity: 1 !important;
    }
  }
`

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SearchIcon = styled.div`
  position: absolute;
  left: 16px;
  z-index: 1;
  pointer-events: none;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 28px;
  height: 28px;

  top: calc(11px);
  transform: translateY(0);

  svg {
    display: block;
    vertical-align: baseline;
    margin-bottom: 0;
  }
`

export const ClearIcon = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 16px;
  margin: auto;
  z-index: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;

  &:hover {
    opacity: 0.8;
  }
`

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FAQItem = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--gray200);
  padding-bottom: 16px;

  &:last-child {
    border-bottom: none;
  }
`

export const QuestionButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--primary500);
    outline-offset: 2px;
    border-radius: 4px;
  }
`

export const QuestionText = styled.div`
  flex: 1;
`

export const AnswerContainer = styled.div`
  margin-top: 8px;
  padding-left: 0;
  animation: slideDown 0.3s ease-out;
`

export const AnswerList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const AnswerItem = styled.li<{ $isFirstItem?: boolean }>`
  padding-left: ${(props) => (props.$isFirstItem ? '0' : '16px')};
  margin-left: ${(props) => (props.$isFirstItem ? '0' : '6px')};
  position: relative;

  &::before {
    content: ${(props) => (props.$isFirstItem ? 'none' : "'•'")};
    position: absolute;
    left: 0;
    color: var(--gray400);
    font-weight: normal;
  }
`

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 24px;
  text-align: center;
`

export const AnswerLink = styled.span`
  color: #ea7100;
  text-decoration: underline;
  font-weight: 400;
  cursor: pointer;
  text-underline-offset: 2px;

  &:hover {
    color: #d16500;
  }

  &:focus {
    outline: 2px solid var(--primary500);
    outline-offset: 2px;
    border-radius: 2px;
  }
`
